import type { TFunction } from 'i18next';

import {
  CreateUpdateParamsDto,
  CreateUpdateParamsDtoFromJSON,
  DefaultApi,
  GetLastEditorDto,
  GetParamsDto,
} from '../autogenerated/pokApiClient';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { paramsForGrid } from '../../../pok/components/Params/ParamsSearch';
import { TKeys } from '../../../translations/keys';
import { ParamsSchema } from '../validation/schemas';
import { validateAgainst } from '../validation/validateAgainst';

export interface ParamsContextInterface {
  getAllByPortion: (
    t: TFunction<'administrationLng', 'administrationLng'>,
    tk: TKeys<'administrationLng'>,
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, filterColumns?: string) => Promise<number>;
  update: (id: string, dto: CreateUpdateParamsDto) => Promise<void>;
  getById: (id: string) => Promise<GetParamsDto>;
  getLastEditor: (id: string) => Promise<GetLastEditorDto>;
  getNewPositionApplicationUrl: () => Promise<string>;
  getContractsForWorkUrl: () => Promise<string>;
}

export const ParamsContext = (api: DefaultApi) => {
  return {
    getAllByPortion: async (
      t: TFunction<'administrationLng', 'administrationLng'>,
      tk: TKeys<'administrationLng'>,
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) => {
      const data = await api.paramsControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        filterColumns,
      );

      return data.map(item => paramsForGrid(t, tk, item));
    },
    getAllCount: async (filterText?: string, filterColumns?: string) =>
      api.paramsControllerGetAllCount(filterText || '', filterColumns),
    update: (id: string, dto: CreateUpdateParamsDto) =>
      api.paramsControllerUpdate(id, dto),
    getById: (id: string) => api.paramsControllerGetById(id),
    getLastEditor: (id: string) => api.paramsControllerGetLastEditor(id),
    getNewPositionApplicationUrl: () =>
      api.paramsControllerGetNewPositionApplicationUrl(),
    getContractsForWorkUrl: () => api.paramsControllerGetContractsForWorkUrl(),
  };
};

export const validate = (param: CreateUpdateParamsDto) =>
  validateAgainst(ParamsSchema, param);

export const convert = (param: GetParamsDto) => {
  return CreateUpdateParamsDtoFromJSON(param);
};
